import React from 'react';
import { withTranslation } from 'react-i18next';

import { getNotificationText } from '../../../common/notifications';
import Action from '../../Action';
import Render from '../../BBcode/Render';
import Card from '../Card';
import DateDisplay from '../DateDisplay';
import UserPicture from '../UserPicture';

import * as style from './style.module.css';

const ActivityFeed = React.memo(
  withTranslation()(({ activities, t, displayType = 'FEED', isScrollable = false, actionFunction = () => { } }) => (
    <Card className={`${isScrollable ? style.isScrollable : ''}`} disablePadding>
      {activities.map((activity) => (
        <div key={activity.node.id} className={`${style.activityLine} ${activity.node.isRead ? style.isRead : ''}`}>
          <div>
            <UserPicture className={style.avatar} {...activity.node.user} animatedPicture={null} />
            <Action action={actionFunction(activity.node.id)} className={style.activityMessage}>
              <Render value={getNotificationText(t, activity.node.type, activity.node.arguments, displayType)} options={{ emojis: [] }} />
            </Action>
          </div>
          <Action action={actionFunction(activity.node.id)} className={style.date}>
            <DateDisplay timestamp={activity.node.createdAt} relative />
          </Action>
        </div>
      ))}
    </Card>
  ))
);

export default ActivityFeed;
